import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { BusinessAreaSystemConnectionHistoryList, LoadingOverlay, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import _ from 'lodash';
import { Row, Col, Typography, Empty } from 'antd';

const { Title, Text } = Typography;

class EventBusinessAreaSystemConnections extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true
        }
    }

    componentWillMount() {
        if (this.props.itemOperation && this.props.eventType === "BATCH_PROCESSING") {
            let headerText = "";
            let headerDetails = `(Business Area: ${this.props.businessAreaName})`
            switch (this.props.itemOperation) {
                case "INSERT":
                    headerText = "Added business area system connections"
                    break;
                case "DELETE":
                    headerText = "Deleted business area system connections"
                    break;
                case "UPDATE":
                    headerText = "Updated business area system connections"
                    break;
            }
            this.setState({
                headerText,
                headerDetails
            });
            this.setState({
                busy: true,
                busyMessage: "Getting business area system connections...",
            });
            this.props.getEventBusinessAreaConnections(this.props.eventId, this.props.itemOperation, null);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventBusinessAreaConnectionsResultUpdate(prevProps);
    }

    onGetEventBusinessAreaConnectionsResultUpdate = (prevProps) => {
        if (this.props.getEventBusinessAreaConnectionsResult && this.props.getEventBusinessAreaConnectionsResult !== prevProps.getEventBusinessAreaConnectionsResult) {
            if (!this.props.getEventBusinessAreaConnectionsResult.success) {
                if (this.props.getEventBusinessAreaConnectionsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get business area system connections at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false
            });
        }
    }

    isBusy = () => {
        let isBusy = (this.state.busy || this.state.fetchingData);
        return isBusy;
    }

    render() {
        return (
            <>
                {
                    this.isBusy()
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message={this.state.busyMessage || "Please wait..."}>
                        </LoadingOverlay>
                        :
                        <></>
                }
                {
                    !this.state.fetchingData
                        ?
                        <FullHeightContainerLayout
                            showHeader={true}
                            showFooter={false}
                            header={<Title level={5}><Text>Event Batch - </Text><Text>{this.state.headerText}</Text><Text> - </Text><Text type="secondary">{this.state.headerDetails}</Text></Title>}
                            content={this.props.connectionsResult ?
                                <BusinessAreaSystemConnectionHistoryList
                                    businessAreaConnectionRevisions={this.props.connectionsResult.Items}>
                                </BusinessAreaSystemConnectionHistoryList>
                                :
                                <Empty></Empty>}>
                        </FullHeightContainerLayout>
                        :
                        <></>
                }

            </>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventBusinessAreaConnectionsResult: state.eventBusinessAreaSystemConnections.getEventBusinessAreaConnectionsResult,
        connectionsResult: state.eventBusinessAreaSystemConnections.connectionsResult
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getEventBusinessAreaConnections: (eventId, itemOperation, pageKey) => dispatch(actions.getEventBusinessAreaConnectionsRequest(eventId, itemOperation, pageKey))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventBusinessAreaSystemConnections));